export const STRUCTURE_TAG_COLORS = {
  REQUIRED: 'required',
  OPTIONAL: 'optional',
  CURRENCY: 'currency',
};
